import React from "react";
import { SbEditableBlok } from "@storyblok/storyblok-editable";
import { ImageV2, ImageV2Props } from "../ImageV2/ImageV2";

export interface SocialIconV2Props {
  blok: SbEditableBlok & {
    iconWithLink: ImageV2Props["blok"][];
  };
  blokClassName?: string;
  key?: string;
}

export function SocialIconV2({ blok: { iconWithLink }, blokClassName, key }: SocialIconV2Props) {
  return (
    <div className={`rounded-full ${blokClassName}`} key={key}>
      <ImageV2 blok={iconWithLink?.[0]} />
    </div>
  );
}
